export default {"src":"https://static.spiritory.com/_next/static/media/auth1.71a95df4.svg","height":139,"width":138,"blurWidth":0,"blurHeight":0};